module.exports = __webpack_public_path__ + "public/img/chu.b14faeee.png";